module.exports = __webpack_public_path__ + "img/idx-title-service.dbe54f6.webp";